module.exports = __webpack_public_path__ + "static/planeta_loving-07cfdcc5d01f3fe805999f601cd25a22.png";